export interface CalculateDeliveryDateRequest {
  salesOrderHeaderId: string;
  productId: string;
  quantity: number;
}
